var map = {
	"./back.png": 707,
	"./background-register.jpg": 708,
	"./ok.png": 709,
	"./register-camera.png": 710,
	"./register-level.png": 711,
	"./register-name.png": 712,
	"./register-picture.png": 713,
	"./register-reset.png": 714,
	"./register.png": 715
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 706;